module.exports = "https://portperrypedals.ca/_res/img/scugog-tv-aug.86c4782.jpg";